import GenericAction from '@Actions/generic-action';
import { clearAuthSessionStorage } from "@Helpers/clear-auth-session-storage";
import { getAuth, signInWithCustomToken } from 'firebase/auth';
export default class ReAuthWithToken extends GenericAction {
  
  runAction() {
    this._disableLoaders = true;
    const Action = async () => {
      try {
        // const user = await this._firebase
        // .auth()
        signInWithCustomToken(getAuth(), this._payload.custom_token);
         this._state.loading.events.resetLoader.emit();

        super.onSuccess();
        // Clear session storage on reauth success to ensure unity specific data is not retained
        clearAuthSessionStorage({ preserveLocale: true });
        // this._dispatch({
        //   type: Actions.AppActions.AnalyticsEvent,
        //   payload: { type: AnalyticsEvents. }
        // });
        return Promise.resolve();
      } catch (error: unknown) {
        super.onError(error);
        return Promise.reject(error);
      }
    };
    Action();
  }
}
